import styled from "styled-components";

export default styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  width: 85%;
  background-color: none;
  color: #fff;
  margin: 15px;
  font-size: 4em;
  outline:none;
  box-shadow: 10px 10px 5px 0px rgba(41,10,61,0.75);
-webkit-box-shadow: 10px 10px 5px 0px rgba(41,10,61,0.75);
-moz-box-shadow: 10px 10px 5px 0px rgba(41,10,61,0.75);
`;
